import { connect } from 'react-redux';
import SmtpConfigurationView from './SmtpConfigurationView.jsx';
import { authenticateAccount, updateSmtpConfiguration } from 'src/legacy/redux/actions/integrations/smtpIntegration.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    errors: state.legacyRootReducer.settings.integrations.smtp.changes.error,
    updating: state.legacyRootReducer.settings.integrations.smtp.changes.saving,
    loading: state.legacyRootReducer.settings.integrations.smtp.changes.loading,
    integration: getIntegrationForType(state, 'smtp'),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (request) => {
      return dispatch(authenticateAccount(request))
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => { 
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  }
}

const SmtpConfigurationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(SmtpConfigurationView);

export default SmtpConfigurationPage;
